// Sign-in step "set up 2-step", only when the rule is `required` and the person has not set it up yet: the same
// set-up as My account, then the recovery codes. The portal opens only after "I have saved them", so the codes
// cannot be skipped by accident.
import { useState } from 'react'
import { RecoveryCodesBox } from '@/components/RecoveryCodesBox'
import { TwoStepSetupPanel, useRefreshAll } from '@/features/account'
import { AuthLayout } from './AuthLayout'

export function SetupStep() {
  const refresh = useRefreshAll()
  const [codes, setCodes] = useState<string[] | null>(null)
  if (codes)
    return (
      <AuthLayout title="Recovery codes" subtitle="2-step sign-in is on. Step 4 of 4.">
        <RecoveryCodesBox codes={codes} onDone={refresh} />
      </AuthLayout>
    )
  return (
    <AuthLayout
      title="Set up 2-step sign-in"
      subtitle="Required for everyone on this portal. About two minutes, with your phone."
    >
      <TwoStepSetupPanel onConfirmed={(session) => setCodes(session.recovery_codes ?? [])} />
    </AuthLayout>
  )
}
